<template>

  <div class="login-wrap">

    <div class="login-bg" aria-hidden="true">

      <div class="login-bg__grid"></div>

      <div class="login-bg__orb login-bg__orb--a"></div>

      <div class="login-bg__orb login-bg__orb--b"></div>

      <div class="login-bg__orb login-bg__orb--c"></div>

    </div>

    <div class="login-card">

      <div class="brand-wrap">

        <img class="brand-logo" :src="logoUrl" alt="EHD Builders logo" />

        <div class="title">{{ $t('app.name') }}</div>

        <div class="subtitle">{{ $t('loginPage.subtitle') }}</div>

      </div>



      <el-form :model="form" :rules="rules" ref="formRef" label-position="top" class="login-form">

        <el-form-item :label="$t('loginPage.account')" prop="username">

          <el-input v-model="form.username" :placeholder="$t('loginPage.accountPh')" prefix-icon="el-icon-user" />

        </el-form-item>

        <el-form-item :label="$t('loginPage.password')" prop="password">

          <el-input v-model="form.password" :placeholder="$t('loginPage.passwordPh')" type="password" prefix-icon="el-icon-lock" />

        </el-form-item>

        <el-form-item class="submit-row">

          <el-button class="login-btn" type="primary" :loading="loading" @click="onLogin">{{ $t('loginPage.submit') }}</el-button>

        </el-form-item>

      </el-form>

      <div v-if="errMsg" class="err">{{ errMsg }}</div>

    </div>

  </div>

</template>



<script>

import { mapActions } from 'vuex'

import logo from '@/assets/images/logo.png'



export default {

  name: 'Login',

  data() {

    return {

      loading: false,

      errMsg: '',

      logoUrl: logo,

      form: {

        username: '',

        password: ''

      }

    }

  },

  computed: {

    rules() {

      return {

        username: [{ required: true, message: this.$t('loginPage.accountRequired'), trigger: 'blur' }],

        password: [{ required: true, message: this.$t('loginPage.passwordRequired'), trigger: 'blur' }]

      }

    }

  },

  methods: {

    ...mapActions(['login']),

    onLogin() {

      this.errMsg = ''

      this.$refs.formRef.validate(async ok => {

        if (!ok) return

        this.loading = true

        try {

          await this.login(this.form)

          this.$router.push('/home')

        } catch (e) {

          this.errMsg = (e && e.message) ? e.message : this.$t('loginPage.failed')

        } finally {

          this.loading = false

        }

      })

    }

  }

}

</script>



<style scoped>

.login-wrap {

  min-height: 100vh;

  display: flex;

  align-items: center;

  justify-content: center;

  background: var(--color-bg);

  background-image:
    radial-gradient(circle at top right, rgba(22, 163, 74, 0.14), transparent 28%),
    radial-gradient(circle at bottom left, rgba(59, 130, 246, 0.08), transparent 30%),
    linear-gradient(135deg, #f8fafc 0%, #eef4f8 50%, #f6f8fb 100%);

  background-size: 200% 200%;

  animation: login-bg-shift 18s ease-in-out infinite;

  position: relative;

  overflow: hidden;

}



@keyframes login-bg-shift {

  0%, 100% { background-position: 0% 50%; }

  50% { background-position: 100% 50%; }

}



.login-bg {

  position: absolute;

  inset: 0;

  pointer-events: none;

  z-index: 0;

  overflow: hidden;

}



.login-bg__grid {

  position: absolute;

  inset: -50%;

  width: 200%;

  height: 200%;

  background-image:

    linear-gradient(rgba(15, 23, 42, 0.04) 1px, transparent 1px),

    linear-gradient(90deg, rgba(15, 23, 42, 0.04) 1px, transparent 1px);

  background-size: 48px 48px;

  transform: perspective(500px) rotateX(60deg);

  transform-origin: center top;

  opacity: 0.35;

  animation: login-grid-drift 40s linear infinite;

}



@keyframes login-grid-drift {

  0% { transform: perspective(500px) rotateX(60deg) translateY(0); }

  100% { transform: perspective(500px) rotateX(60deg) translateY(48px); }

}



.login-bg__orb {

  position: absolute;

  border-radius: 50%;

  filter: blur(60px);

  opacity: 0.55;

  animation: login-orb-float 12s ease-in-out infinite;

}



.login-bg__orb--a {

  width: min(55vw, 420px);

  height: min(55vw, 420px);

  background: radial-gradient(circle, rgba(74, 222, 128, 0.35) 0%, transparent 65%);

  top: -8%;

  right: -5%;

  animation-delay: 0s;

}



.login-bg__orb--b {

  width: min(45vw, 360px);

  height: min(45vw, 360px);

  background: radial-gradient(circle, rgba(34, 197, 94, 0.22) 0%, transparent 65%);

  bottom: -12%;

  left: -8%;

  animation-delay: -4s;

}



.login-bg__orb--c {

  width: min(35vw, 280px);

  height: min(35vw, 280px);

  background: radial-gradient(circle, rgba(16, 185, 129, 0.18) 0%, transparent 70%);

  top: 42%;

  left: 50%;

  transform: translateX(-50%);

  animation-name: login-orb-float-center;

  animation-delay: -8s;

}



@keyframes login-orb-float {

  0%, 100% { transform: translate(0, 0) scale(1); opacity: 0.5; }

  33% { transform: translate(12px, -18px) scale(1.05); opacity: 0.65; }

  66% { transform: translate(-16px, 10px) scale(0.96); opacity: 0.45; }

}



@keyframes login-orb-float-center {

  0%, 100% { transform: translateX(-50%) translateY(0) scale(1); opacity: 0.4; }

  50% { transform: translateX(-50%) translateY(-24px) scale(1.08); opacity: 0.6; }

}



.login-card {

  width: 420px;

  max-width: calc(100vw - 32px);

  background: rgba(255, 255, 255, 0.9);

  backdrop-filter: blur(12px);

  -webkit-backdrop-filter: blur(12px);

  padding: 36px 36px 40px;

  border-radius: 18px;

  border: 1px solid var(--color-border);

  box-shadow:

    0 0 0 1px rgba(22, 163, 74, 0.06),

    0 24px 64px rgba(15, 23, 42, 0.14),

    0 0 80px rgba(22, 163, 74, 0.06);

  position: relative;

  z-index: 1;

  animation: login-card-in 0.65s cubic-bezier(0.22, 1, 0.36, 1) both;

}



@keyframes login-card-in {

  from {

    opacity: 0;

    transform: translateY(20px) scale(0.98);

  }

  to {

    opacity: 1;

    transform: translateY(0) scale(1);

  }

}



.login-card::before {

  content: '';

  position: absolute;

  inset: 0;

  border-radius: 18px;

  background: linear-gradient(

    145deg,

    rgba(74, 222, 128, 0.12) 0%,

    transparent 42%,

    transparent 58%,

    rgba(74, 222, 128, 0.06) 100%

  );

  pointer-events: none;

  opacity: 1;

}



.brand-wrap {

  text-align: center;

  margin-bottom: 28px;

}



.brand-logo-wrap {

  display: inline-flex;

  align-items: center;

  justify-content: center;

  width: 52px;

  height: 52px;

  background: linear-gradient(135deg, #4ade80, #16a34a);

  border-radius: 14px;

  margin-bottom: 14px;

  box-shadow: 0 6px 20px rgba(74, 222, 128, 0.3);

}



.brand-logo {

  width: 90px;

  max-width: 100%;

  height: auto;

  object-fit: contain;

  filter: drop-shadow(0 8px 24px rgba(74, 222, 128, 0.2));

  animation: login-logo-glow 4s ease-in-out infinite;

}



@keyframes login-logo-glow {

  0%, 100% { filter: drop-shadow(0 8px 20px rgba(74, 222, 128, 0.15)); }

  50% { filter: drop-shadow(0 10px 32px rgba(74, 222, 128, 0.35)); }

}



.title {

  font-size: 22px;

  font-weight: 700;

  color: var(--color-text);

  margin: 0 0 6px;

  letter-spacing: -0.01em;

}



.subtitle {

  margin: 0;

  color: var(--color-text-sub);

  font-size: 13.5px;

}



.login-form {

  margin-top: 4px;

}



.login-form :deep(.el-form-item__label) {

  display: block;

  float: none;

  color: var(--color-text) !important;

  font-size: 14px !important;

  font-weight: 500;

  line-height: 1.4;

  padding: 0 0 8px !important;

}



.login-form :deep(.el-form-item) {

  margin-bottom: 16px;

}



.login-form :deep(.el-form-item__content) {

  margin-left: 0 !important;

  line-height: normal;

}



.login-form :deep(.el-input__prefix) {

  left: 12px;

  color: var(--color-text-muted);

}



.login-form :deep(.el-input__prefix .el-input__icon) {

  font-size: 15px;

  line-height: 42px;

}



.login-form :deep(.el-input--prefix .el-input__inner) {

  padding-left: 38px;

}



.login-form :deep(.el-input__inner) {

  height: 42px;

  line-height: 42px;

  padding: 10px 14px;

  border-radius: 9px;

  box-sizing: border-box;

  background: #ffffff !important;

  border: 1px solid var(--color-border) !important;

  color: var(--color-text) !important;

  font-size: 14px;

}



.login-form :deep(.el-input__inner)::placeholder {

  color: var(--color-text-muted) !important;

}



.login-form :deep(.el-input__inner):focus {

  border-color: rgba(74, 222, 128, 0.5) !important;

  box-shadow: 0 0 0 3px rgba(74, 222, 128, 0.08) !important;

}



.submit-row {

  margin-top: 8px;

  margin-bottom: 0;

}



.login-btn {

  display: block;

  width: 100%;

  height: 44px;

  border-radius: 10px;

  font-weight: 600;

  font-size: 14px;

  box-sizing: border-box;

  background: linear-gradient(135deg, #22c55e, #16a34a) !important;

  border: none !important;

  color: #fff !important;

  transition: all 0.2s ease;

  box-shadow: 0 4px 14px rgba(74, 222, 128, 0.3);

}



.login-btn:hover,

.login-btn:focus {

  box-shadow: 0 6px 20px rgba(74, 222, 128, 0.45) !important;

  transform: translateY(-1px);

}

.err {

  color: #f87171;

  margin-top: 14px;

  font-size: 13px;

  text-align: center;

  padding: 8px 12px;

  background: rgba(248, 113, 113, 0.08);

  border-radius: 7px;

  border: 1px solid rgba(248, 113, 113, 0.15);

}

</style>

<style>
:root[data-theme="dark"] .login-wrap {
  background: #07080d;
  background-image: linear-gradient(125deg, #07080d 0%, #0d1218 40%, #0a1620 70%, #07080d 100%);
}

:root[data-theme="dark"] .login-bg__grid {
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
}

:root[data-theme="dark"] .login-card {
  background: linear-gradient(160deg, rgba(28, 32, 42, 0.92) 0%, rgba(20, 23, 31, 0.96) 100%);
  border-color: rgba(255, 255, 255, 0.09);
  box-shadow:
    0 0 0 1px rgba(74, 222, 128, 0.06),
    0 24px 64px rgba(0, 0, 0, 0.55),
    0 0 80px rgba(74, 222, 128, 0.04);
}

:root[data-theme="dark"] .login-form .el-input__inner {
  background: #1f2330 !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
  color: #e2e8f0 !important;
}
</style>


